import createClient, { type Middleware } from "openapi-fetch";
import type { paths, components } from "./v1";

// Re-export commonly used types
export type LocaleCode = components["schemas"]["LocaleCode"];
export type KnownLanguageCode = components["schemas"]["KnownLanguageCode"];
export type Difficulty = "beginner" | "intermediate" | "advanced";
export type Richness = "compact" | "standard" | "comprehensive";

const authMiddleware: Middleware = {
  async onRequest({ request }) {
    if (typeof window !== "undefined") {
      const pw = sessionStorage.getItem("saysay-auth");
      if (pw) request.headers.set("x-app-password", pw);
    }
    return request;
  },
};

const api = createClient<paths>({
  baseUrl: process.env.NEXT_PUBLIC_API_URL || "",
});
api.use(authMiddleware);

export default api;
